@if (!isLoading) {
  <div (dblclick)="onImageDoubleClick($event)" (click)="disableContextMenu()" oncontextmenu="return false;"
    style="height: 100%; background-color: lightgray; border-radius: var(--border-radius); display: flex; flex-direction: column;" data-cy="tdo-imaging-image-container">
    <table style="width:100%;" data-cy="tdo-imaging-image-header-table">
      <tr data-cy="tdo-imaging-image-header-row">
        <td style="width:20%" data-cy="tdo-imaging-image-header-tooth-dropdown-cell">
          <tdo-multi-dropdown (selectedItems)="onCaseToothSelectionChange($event)"
            [dataset]="toothDetailList" [selected]="xImage.selectedTeeth" displayKey="Notation" displayKeyByCase="NotationDescription" [isMultipleCaseItem]="isMultipleCaseItem"
            [ngClass]="isMultipleCaseItem ? 'tdo-dropdown-menu-item-ByCase' : 'tdo-dropdown-menu-item'"
            [width]="!isMultipleCaseItem ? '150px' : '100%'"
          [isDisabled]="isDisabled" data-cy="tdo-imaging-image-tooth-dropdown"></tdo-multi-dropdown>
        </td>
        <td style="width:30%" data-cy="tdo-imaging-image-header-add-teeth-cell">
          <div style="width: 100%; display: flex; " data-cy="tdo-imaging-image-add-teeth-container">
            <div data-cy="tdo-imaging-image-add-teeth-btn-container">
              <button [ngStyle]="{'cursor': !globals.currentPatientCaseWorkItemID || globals.currentPatientCaseWorkItemID === '00000000-0000-0000-0000-000000000000' ? 'default' : 'pointer', 'opacity': !globals.currentPatientCaseWorkItemID || globals.currentPatientCaseWorkItemID === '00000000-0000-0000-0000-000000000000' ? 0.5 : 1}"
                mat-icon-button color="primary" class="tdo-button"
                [matTooltip]="!globals.currentPatientCaseWorkItemID || globals.currentPatientCaseWorkItemID === '00000000-0000-0000-0000-000000000000' ? 'You must select a procedure' : 'Add teeth'"
                (click)="openDialogEditTeeth()"
                style="width: 10%;" data-cy="tdo-imaging-image-add-teeth-btn">
                <img style="width:100%;" src="assets/Images/Calendar/iconToothNew.svg" data-cy="tdo-imaging-image-add-teeth-icon"/>
              </button>
            </div>
          </div>
        </td>
        <td style="width:10% ;" data-cy="tdo-imaging-image-header-spacer1"></td>
        <td style="width:10%" data-cy="tdo-imaging-image-header-spacer2"></td>
        <td style="width:30%; text-align: right;" data-cy="tdo-imaging-image-header-controls-cell">
          <div style="flex-basis: fit-content;" data-cy="tdo-imaging-image-controls-container">
            <div style="width: fit-content; display: flex; margin-left: auto; margin-right: 0; margin-top: 7px;" data-cy="tdo-imaging-image-controls">
              <div style="margin-right: 10px;" matTooltip="Date Taken" data-cy="tdo-imaging-image-date">
                {{getDate(document?.DocumentCreateDate?.toString())}}
              </div>
              <div data-cy="tdo-imaging-image-edit-date-container" *ngIf="!xImage?.deviceId">
                <lucide-icon name="calendar" [size]="20" style="cursor: pointer;z-index: 2000" (click)="openChangeDateDialog()" matTooltip="Change Taken Date" data-cy="tdo-imaging-image-edit-date-btn"></lucide-icon>
              </div>
              <lucide-icon name="maximize-2" [size]="20" style="cursor: pointer;" (click)="onOpenInFull()" matTooltip="Max/Min" data-cy="tdo-imaging-image-maximize-btn"></lucide-icon>
              <lucide-icon name="x" [size]="20" style="cursor: pointer;" (click)="onClose()" matTooltip="Close" data-cy="tdo-imaging-image-close-btn"></lucide-icon>
            </div>
          </div>
        </td>
      </tr>
    </table>
    <div style="width: 100%; height: 100%; position: relative;" data-cy="tdo-imaging-image-viewer-container">
      @if (isSaving) {
        <app-tdo-progress-spinner style="position: absolute; z-index: 2000;" data-cy="tdo-imaging-image-spinner"></app-tdo-progress-spinner>
      }
      @if (imageLoadErrorMessage) {
        <div class="image-load-error" data-cy="tdo-imaging-image-load-error">
          <lucide-icon name="alert-triangle" [size]="32" data-cy="tdo-imaging-image-load-error-icon"></lucide-icon>
          <div data-cy="tdo-imaging-image-load-error-message">{{imageLoadErrorMessage}}</div>
          <button mat-raised-button color="primary" (click)="retryImageLoad()" data-cy="tdo-imaging-image-load-error-retry-btn">Retry</button>
        </div>
      }
      <div [id]="ImageName"
        class="tdo-image-viewer"
        style="background-color: #E1E3E3; width: 100%; height: 100%;"
        (contextmenu)="onrightClick($event)"
        (keydown.delete)="deleteAnnotationBtn_Click($event)"
        (keydown.control)="ctrlKeyBtn_Click($event)"
      (keyup.control)="ctrlKeyBtnRelease_Click($event)" data-cy="tdo-imaging-image-viewer"></div>
      <select (change)="onObjectChange($event)" id="currentObject" style="display:none;" data-cy="tdo-imaging-image-current-object"></select>
      <select id="userMode" style="display:none;" data-cy="tdo-imaging-image-user-mode">
        <option>Design</option>
        <option>Run</option>
      </select>
    </div>
    <div class="bottom-status" data-cy="tdo-imaging-image-bottom-status">
      <div style="flex: 1; margin: 5px; max-height: 100%; max-width: 100%; overflow-x: auto; overflow-y: hidden; flex-wrap: nowrap;" class="category-pills" data-cy="tdo-imaging-image-tags-container">
        @if (document && document.dataDocumentTags) {
          @for (tag of document.dataDocumentTags; track tag) {
            <div class="pill"
              style="background-color: #333333; border: 1px solid var(--tdo-primary-accent); color: white; display: flex; height: 30px; font-size: 14px; flex-basis: fit-content; min-width: fit-content;"
              data-cy="tdo-imaging-image-tag-pill-{{tag.enumDocumentTag.ItemDisplayValue}}">
              <div style="flex: 1;" data-cy="tdo-imaging-image-tag-text">{{tag.enumDocumentTag.ItemDisplayValue}}</div>
              <div [matTooltip]="'Delete ' + tag.enumDocumentTag.ItemDisplayValue" (click)="deleteTag(tag)"
                style="margin-left: 8px; position: relative; cursor: pointer; width: 20px; color: var(--tdo-primary-accent);" data-cy="tdo-imaging-image-tag-delete">
                <lucide-icon name="x-circle" [size]="20" data-cy="tdo-imaging-image-tag-delete-icon"></lucide-icon>
              </div>
            </div>
          }
        }
      </div>
      @if (isRotation==true) {
        <div [ngStyle]="{'opacity': document ? 1 : 0.4, 'user-events': document ? 'all' : 'none'}"
          style="flex-basis: fit-content; color: var(--tdo-primary); margin-top: 8px;" (click)="onStopRotation()" data-cy="tdo-imaging-image-stop-rotation-container">
          <button mat-raised-button matTooltip="Stop rotation" data-cy="tdo-imaging-image-stop-rotation-btn">Stop Rotation</button>
        </div>
      }
      <div [ngStyle]="{'opacity': document ? 1 : 0.4, 'user-events': document ? 'all' : 'none'}"
        style="flex-basis: fit-content; color: var(--tdo-primary); margin-top: 8px;" (click)="onEditTagsClick()" data-cy="tdo-imaging-image-add-tags-container">
        <lucide-icon name="plus-circle" [size]="20" style="cursor: pointer;" matTooltip="Add tags" data-cy="tdo-imaging-image-add-tags-btn"></lucide-icon>
      </div>
    </div>
  </div>
}
<!--you have to write this only once in your component-->
@if (contextmenu==true) {
  <div data-cy="tdo-imaging-image-contextmenu-container">
    <app-tdo-imaging-contextmenu [x]="contextmenuX"
      [y]="contextmenuY"
      [isRuler]="isRuler"
      (imagingContextMenuEvent)="onImagingContextMenu($event)" data-cy="tdo-imaging-image-contextmenu">
    </app-tdo-imaging-contextmenu>
  </div>
}
